export interface Timestamp {
  seconds: number;
  nanos: number;
}

export function toDate(timestamp: Timestamp): Date {
  return new Date(timestamp.seconds * 1000);
}
